import React from 'react';
import { Radio } from 'antd';

interface RadioFieldProps {
  value?: any;
  onChange?: (value: any) => void;
  options?: Array<{ label: string; value: any; disabled?: boolean }>;
  buttonStyle?: 'outline' | 'solid';
  size?: 'large' | 'middle' | 'small';
  disabled?: boolean;
  [key: string]: any;
}

export const RadioField: React.FC<RadioFieldProps> = ({
  value,
  onChange,
  options = [],
  buttonStyle = 'solid',
  size = 'middle',
  disabled = false,
  ...props
}) => {
  return (
    <Radio.Group
      value={value}
      onChange={e => onChange?.(e.target.value)}
      buttonStyle={buttonStyle}
      size={size}
      disabled={disabled}
      {...props}
    >
      {options.map(option => (
        <Radio.Button
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};
